export interface Role_Responder_VideoType {
  _id: string;
  address?: string;
  date: string;
  insight: string;
  keywords: string[];
  locality: string;
  name: string;
  postcode: string;
  provider: string;
  thumbnail: string[];
  videoURL: string;
  camera?: string;
  duration?: number;
  location: { coordinates: number[] };
  orientation?: string;
  coordinates?: number[];
}

export interface Role_Officer_VideoType {
  _id: string;
  address: string;
  date: string;
  insight: string;
  keywords: string[];
  locality: string;
  name: string;
  postcode: string;
  provider: string;
  thumbnail: string[];
  videoURL: string;
}

export interface FormValues {
  camera: string;
  date: string;
  insight: string;
  keywords: string;
  suburb: string;
  name: string;
  orientation: string;
  postcode: string;
  provider: string;
  sensitivity: string;
  street: string;
  // thumbnail1: File | undefined;
  // thumbnail2: File | undefined;
  // thumbnail3: File | undefined;
  submit: boolean;
  videoURL: string;
  location: string;
}

export interface FormValuesForApiCall {
  camera: string;
  date: string;
  dateRough: string;
  insight: string;
  keywords: string[];
  suburb?: string;
  name: string;
  orientation: string;
  postcode: string;
  provider: string;
  sensitivity: string;
  street: string;
  // thumbnail: File[] | [];
  submit?: boolean;
  videoURL: string;
  videoPreviewURL: string;
  duration: number;
  locality: string;
  location: { type: string; coordinates: number[] };
}

export interface VideoType {
  _id: string;
  camera: string;
  date: string;
  dateRough: string;
  insight: string;
  keywords: string[];
  suburb?: string;
  name: string;
  orientation: string;
  postcode: string;
  provider: string;
  sensitivity: string;
  street: string;
  thumbnail: string[];
  submit?: boolean;
  videoURL: string;
  videoPreviewURL: string;
  duration: number;
  locality: string;
  location: { type: string; coordinates: number[] };
}

export function capWord(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
